export default {
  setCommentList(state, data) {
    state.comment_list = data
  },
  setTopCommentList(state, data) {
    state.top_comment_list = data
  }
}